import upgradeEngine from '../upgradeEngine';

export const tryUpgradeDocumentAsync = (document, template, api) =>
    upgradeEngine(template).tryUpgradeAsync(document, api);
